(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59904,7797,5783,56012,75978,91058,99257,59654,55004,6050,12701,59679,68837,54223,6169,13054,59544,54042,19341,97,33030],{

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 74233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_NumberedListSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/NumberedListSection/utils/useNumberedListSection.js




/* harmony default export */ function useNumberedListSection(_param) {
    var sectionData = _param.sectionData, type = _param.type, handleOnCTAClick = _param.handleOnCTAClick, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "sectionData",
        "type",
        "handleOnCTAClick"
    ]);
    var ref = (0,helper/* getDocumentFields */.OA)(sectionData, [
        "title",
        "description",
        "contentModules",
        "view", 
    ]), contentModules = ref.contentModules, title = ref.title, description = ref.description, view = ref.view;
    var linkData = get_default()(contentModules, "[1]");
    var ref1 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", [])), listData = ref1.contentModules;
    var list = (listData || []).map(function(item) {
        return (0,helper/* getDocumentFields */.OA)(item, [
            "title"
        ]).title;
    });
    return (0,_object_spread/* default */.Z)({
        title: title,
        description: description,
        view: view,
        list: list,
        type: type,
        handleOnCTAClick: handleOnCTAClick,
        linkData: linkData
    }, rest);
};

// EXTERNAL MODULE: ./UI/sections/NumberedListSection/styles.module.scss
var styles_module = __webpack_require__(91935);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/NumberedListSection/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var NumberWithText = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 97062).then(__webpack_require__.bind(__webpack_require__, 97062));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97062)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 49617).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var NumberedListSection = function(props) {
    var ref = useNumberedListSection(props), list = ref.list, type = ref.type, view = ref.view, title = ref.title, description = ref.description, handleOnCTAClick = ref.handleOnCTAClick, noCardBackground = ref.noCardBackground, linkData = ref.linkData;
    if (!list.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((styles_module_default()).checkListSection, (styles_module_default())[type], (styles_module_default())[view]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    description: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).checkList,
                    children: list.map(function(text, index) {
                        return /*#__PURE__*/ (0,react.createElement)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                            key: "numbered-list/".concat(index),
                            transitionDelay: 50 * index
                        }), /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberWithText, {
                            value: index + 1,
                            className: (styles_module_default()).card,
                            noBackground: noCardBackground,
                            children: text
                        }));
                    })
                }),
                linkData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                        data: linkData,
                        handleOnClick: handleOnCTAClick,
                        className: (styles_module_default()).callToAction
                    })
                }))
            ]
        })
    });
};
NumberedListSection.defaultProps = {
    handleOnCTAClick: function() {}
};
NumberedListSection.propTypes = {
    sectionData: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired,
    handleOnCTAClick: (prop_types_default()).func
};
/* harmony default export */ var sections_NumberedListSection = (NumberedListSection);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 91935:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__RJUMt","cards":"styles_cards__D3Xvq","imageWrapper":"styles_imageWrapper__gAwQk","typeTitle":"styles_typeTitle__TS21k","greySection":"styles_greySection__0JNrO","callToAction":"styles_callToAction__J_WAg","threeColumnsCards":"styles_threeColumnsCards__VhiQQ","twoColumnsCards":"styles_twoColumnsCards__hsJdg","textContent":"styles_textContent__wBIWJ","graySection":"styles_graySection__9pZiL","ui-ux-services":"styles_ui-ux-services__tVidz","firstSectionView":"styles_firstSectionView__MJVwz","checkListSection":"styles_checkListSection__0jC0_","contentWrapper":"styles_contentWrapper__kSmZM","checkList":"styles_checkList__WxmUl","card":"styles_card__1htJC"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);